import styled from 'styled-components';

export const CompanyDataContainer = styled.div.attrs({})``;

export const CloseContainer = styled.div.attrs({})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid ${(props) => props.theme.palette.colors.shadow};
  padding-bottom: 12px;
`;
